import {Component, OnInit} from '@angular/core';
import {formatDate} from '@angular/common';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {DadProductService} from '../../services/dad-product.service';

@Component({
  selector: 'app-dad-product-price-crud',
  templateUrl: './dad-product-price-crud.component.html',
  styleUrls: ['./dad-product-price-crud.component.scss']
})
export class DadProductPriceCrudComponent implements OnInit {

  dadProductPriceForm: UntypedFormGroup;
  currenciesList: SelectItem[];
  errorMessage = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private dadProductService: DadProductService) {
  }

  ngOnInit() {
    this.createFormGroup();
    this.initCurrencySelectList();
    this.initialiseFormGroup();
  }

  private initCurrencySelectList() {
    this.currenciesList = [
      {label: 'USD', value: 'USD'},
      {label: 'EUR', value: 'EUR'},
      {label: 'CHF', value: 'CHF'},
      {label: 'GBP', value: 'GBP'},
      {label: 'JPY', value: 'JPY'},
      {label: 'SGD', value: 'SGD'},
    ];
  }

  private initialiseFormGroup() {
    const selectedDadProduct = this.config.data['selectedDadProduct'];
    this.dadProductPriceForm.get('market').setValue(this.config.data['selectedMarket'].name);
    this.dadProductPriceForm.get('productType').setValue(selectedDadProduct ? selectedDadProduct.productType : 'Standard product code');
    this.dadProductPriceForm.get('productCode').setValue(selectedDadProduct ? selectedDadProduct.productCode : '');
  }

  createFormGroup() {
    this.dadProductPriceForm = this.formBuilder.group(
      {
        id: [''],
        market: [''],
        productType: [''],
        productCode: ['', Validators.required],
        amount: ['0', Validators.required],
        currency: ['USD'],
        startDate: [new Date()],
      },
    );
  }

  addDadProductPrice() {
    const startDate = formatDate(this.dadProductPriceForm.get('startDate').value, 'yyyy-MM-dd', 'en-US');
    const dadProductPrice = {...this.dadProductPriceForm.value, startDate};
    this.dadProductService.createDadProduct(dadProductPrice).subscribe({
      next: res => {
        this.ref.close({...dadProductPrice, id: res['id']});
      },
      error: error => {
        const message = error.error?.message;
        this.errorMessage = 'The price could not be saved' + (message ? ': ' + message : '. Please try again.');
      }
    });
  }

}
